import axios from "axios";
import { ElMessage } from "element-plus";
import router from "@/routes";

export const baseUrl = import.meta.env.VITE_API_ENDPOINT ?? '__VITE_API_ENDPOINT__'

const instance = axios.create({
    baseURL: baseUrl + '/api',
    timeout: 10000, // Request timeout
});

instance.defaults.headers.common['Accept'] = "application/json"
instance.defaults.withCredentials = true
instance.defaults.withXSRFToken = true

instance.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        if (error.response.status === 401) {
            window.location.replace('/logout')
        }
        if (error.response.status === 402) {
            router.push({name: 'subscription'})
        }
        if (error.response.data.error_msg) {
            ElMessage.error(error.response.data.error_msg);
        } else if (error.response.data.message) {
            ElMessage.error(error.response.data.message);
        } else {
            ElMessage.error("unexpected error");
        }
        return Promise.reject(error);
    }
);

export default instance;
